// token key
const ACCESS_TOKEN_KEY = 'WH_ACCESS__TOKEN__'
const REFRESH_TOKEN_KEY = 'WH_REFRESH__TOKEN__'
const TOKEN_EXPIRETIME_KEY = 'WH_TOKEN__EXPIRETIME__'
const TOKEN_JWT_PREFIX_KEY = 'Bearer '

// token type
export const TOKEN_TYPE = 'jwt'

export function getAccessToken() {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY)
}

export function getRefreshToken() {
  return sessionStorage.getItem(REFRESH_TOKEN_KEY)
}

export function getTokenExpireTime() {
  return sessionStorage.getItem(TOKEN_EXPIRETIME_KEY)
}

export function setAuth(data) {
  const { AccessToken, RefreshToken, RefreshUtcExpires } = data
  sessionStorage.setItem(ACCESS_TOKEN_KEY, `${TOKEN_JWT_PREFIX_KEY}${AccessToken}`)
  sessionStorage.setItem(REFRESH_TOKEN_KEY, RefreshToken)
  sessionStorage.setItem(TOKEN_EXPIRETIME_KEY, RefreshUtcExpires)
}

export function clearAuth() {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_EXPIRETIME_KEY)
  // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
  // ルート権限検証 MFA 完了チェックの追加
  // MFAフラグをクリア
  sessionStorage.removeItem('mfaCompleted')
  // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
}
